import { MenuItem, TextField, Select, InputAdornment } from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";

export function AgMuiSelect(props) {
    const { options, width, disableUnderline,values=[],height ,iconComponent, backgroundColor, iconColor, size,value,onChange,startIcon,fontSize,fontColor, ...restProps } = props;
    const { style, ...rProps} = restProps;
    console.log("The rest props has ",rProps)
    return (
        <CustomStyledTextField value={value} onChange={onChange}
        SelectProps={{
            IconComponent :iconComponent &&(
                ()=><img style={{margin:8}} src={iconComponent}/>
            )
        }}
        inputProps={{min: 0, style: { textAlign: 'center' }}} 
        InputProps={{
            startAdornment : startIcon && (
                <InputAdornment>
                    <img style={{width:'40px',height:"40px"}} src={startIcon} />
                </InputAdornment>
            ),
            disableUnderline,
            style: {
                paddingLeft:"3px",
                fontSize : fontSize ||  "16px" ,
                color: fontColor || "black",
                fontFamily:"Figtree",
                backgroundColor:backgroundColor || "",
                display:"flex",
                alignItems : "center",
                "&:focused" :{
                    backgroundColor : backgroundColor || "transparent"
                },
                justifyContent:"center",
                textAlign:"start",
                height:height,
                ...style
            }
        }} sx={{
            
            minWidth: width || "90px",
            '& .MuiSelect-icon': {
                color: iconColor || "inherit",
            },
        }} size={size || "small"} fullWidth  {...rProps} select
        >
            {options?.map((option,i) => <MenuItem style={{ display: 'flex', alignItems: 'center' }} value={values.length>0? values[i] :option}>{option}</MenuItem>)}
        </CustomStyledTextField>
    );
}